<!-- GeofenceIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <!-- Radius Circle (outer geofence boundary) -->
    <circle 
      cx="12" 
      cy="12" 
      r="9" 
      stroke="#10b981" 
      stroke-width="1.5" 
      stroke-dasharray="2 2"
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
      opacity="0.6"
    />
    
    <!-- Map Pin Base -->
    <path 
      d="M12 2C8.5 2 5.5 4.8 5.5 8.5C5.5 13 12 20 12 20C12 20 18.5 13 18.5 8.5C18.5 4.8 15.5 2 12 2Z" 
      stroke="#333333" 
      stroke-width="1.5" 
      fill="#10b981"
      fill-opacity="0.2"
      stroke-miterlimit="10" 
      stroke-linecap="round" 
      stroke-linejoin="round"
    />
    
    <!-- Inner Pin Circle -->
    <circle 
      cx="12" 
      cy="8.5" 
      r="2.5" 
      stroke="#333333" 
      stroke-width="1.5"
      fill="#10b981"
    />
    
    <!-- Corner markers showing geofence area -->
    <path d="M4 4L6 6" stroke="#10b981" stroke-width="1.2" stroke-linecap="round"/>
    <path d="M20 4L18 6" stroke="#10b981" stroke-width="1.2" stroke-linecap="round"/>
    <path d="M4 20L6 18" stroke="#10b981" stroke-width="1.2" stroke-linecap="round"/>
    <path d="M20 20L18 18" stroke="#10b981" stroke-width="1.2" stroke-linecap="round"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>